// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Grid,
  Stack,
  CardContent,
  Typography,
  Button,
  Skeleton,
} from '@mui/material';

import { ProductContext } from '@/context/EcommerceContext';
import emptyCart from '@/assets/images/products/empty-shopping-cart.svg';
import BlankCard from '@/components/shared/BlankCard';
import { useTranslation } from '@/hooks/useTranslation';

const ProductList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const { filteredAndSortedProducts, filterReset, loading, error } =
    useContext(ProductContext);

  const handleProductClick = (productId: string) => {
    navigate(`/checkout?productId=${productId}`);
  };

  // Show error if API failed
  if (error) {
    return (
      <Box textAlign="center" mt={6}>
        <Typography variant="h6" color="error" mb={3}>
          {error}
        </Typography>
        <Button variant="contained" onClick={filterReset}>
          {t('shop.tryAgain')}
        </Button>
      </Box>
    );
  }
  return (
    <Box>
      {/* ------------------------------------------- */}
      {/* Header Detail page */}
      {/* ------------------------------------------- */}
      {/* ------------------------------------------- */}
      {/* Page Listing product */}
      {/* ------------------------------------------- */}
      <Grid container spacing={3}>
        {filteredAndSortedProducts.length > 0 ? (
          <>
            {filteredAndSortedProducts.map((product: any) => (
              <Grid
                display="flex"
                alignItems="stretch"
                key={product.externalId}
                size={{
                  xs: 12,
                  lg: 4,
                  md: 4,
                  sm: 6,
                }}
              >
                {/* ------------------------------------------- */}
                {/* Product Card */}
                {/* ------------------------------------------- */}
                {loading ? (
                  <>
                    <Skeleton
                      variant="rectangular"
                      width={270}
                      height={300}
                      sx={{
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-expect-error
                        borderRadius: theme => theme.shape.borderRadius / 5,
                      }}
                    ></Skeleton>
                  </>
                ) : (
                  <BlankCard
                    className="hoverCard"
                    sx={{ position: 'relative' }}
                  >
                    {/*<Tooltip title="Buy Now">*/}
                    {/*  <Fab*/}
                    {/*    size="small"*/}
                    {/*    color="primary"*/}
                    {/*    onClick={(e) => {*/}
                    {/*      e.stopPropagation();*/}
                    {/*      handleProductClick(product.externalId);*/}
                    {/*    }}*/}
                    {/*    sx={{*/}
                    {/*      bottom: '75px',*/}
                    {/*      right: '15px',*/}
                    {/*      position: 'absolute',*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    <IconShoppingCart size="16" />*/}
                    {/*  </Fab>*/}
                    {/*</Tooltip>*/}
                    <CardContent sx={{ p: 3, pt: 2 }}>
                      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                        [ {product.name} ]
                      </Typography>
                      <Typography variant="h4" color="primary" mt={1}>
                        {product.credits} {t('shop.credits')}
                      </Typography>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        mt={1}
                      >
                        <Stack direction="row" alignItems="end">
                          <Typography variant="h2">
                            €{product.discountPrice}
                          </Typography>
                          {product.discountPrice !== product.price && (
                            <Typography
                              color="textSecondary"
                              ml={1}
                              sx={{
                                textDecoration: 'line-through',
                                marginBottom: '2px',
                              }}
                              variant="h3"
                            >
                              €{product.price}
                            </Typography>
                          )}
                          <Typography ml={1} variant="h2">
                            /
                          </Typography>
                          <Typography ml={1} variant="body1">
                            {product.credits} credits
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack>
                        <Typography
                          variant="body1"
                          mt={1}
                          sx={{ fontWeight: 'bold' }}
                          color="textSecondary"
                        >
                          {product.discountPrice !== product.price &&
                          Number(product.price) > 0 ? (
                            `${t('shop.discountLabel')} -${Math.round(
                              (1 -
                                Number(product.discountPrice) /
                                  Number(product.price)) *
                                100
                            )}%`
                          ) : (
                            <div
                              style={{ color: 'transparent', minHeight: '26px' }}
                            >
                              {' '}
                            </div>
                          )}
                        </Typography>
                      </Stack>
                      <Button
                        variant="contained"
                        onClick={e => {
                          e.stopPropagation();
                          handleProductClick(product.externalId);
                        }}
                        sx={{ mt: 2, width: '100%' }}
                      >
                        {t('shop.buyNow')}
                      </Button>
                    </CardContent>
                  </BlankCard>
                )}
                {/* ------------------------------------------- */}
                {/* Product Card */}
                {/* ------------------------------------------- */}
              </Grid>
            ))}
          </>
        ) : (
          <>
            <Grid
              size={{
                xs: 12,
                lg: 12,
                md: 12,
                sm: 12,
              }}
            >
              <Box textAlign="center" mt={6}>
                <img src={emptyCart} alt="cart" width="200px" />
                <Typography variant="h2">{t('shop.noProduct')}</Typography>
                <Typography variant="h6" mb={3}>
                  {t('shop.productNoLongerAvailable')}
                </Typography>
                <Button variant="contained" onClick={filterReset}>
                  {t('shop.tryAgain')}
                </Button>
              </Box>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default ProductList;
